<template>
  <header class="app-header navbar">
    <slot></slot>
  </header>
</template>
<script>
export default {
  name: 'navbarApp',
  created () {
    this._navbar = true
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/layout/Navbar.vue